module.exports = __webpack_public_path__ + "static/pic05-ed59fcaa1ecb04bbca68214450449a46.jpg";